import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../reducer";
import { notebookPagesSelectors } from "../slices/pages";
import { NotebookPage } from "../types/note";

export const selectNotebookPages = (state: RootState) =>
  notebookPagesSelectors.selectEntities(state);

export const selectSelectedNotebookPageId = (state: RootState) =>
  state.pages.selectedNotebookPageId;

export const selectNoteEdits = (state: RootState) => state.pages.noteEdits;

export const selectNotebook = (state: RootState) => state.pages.notebook;

export const makeSelectNotebookPage = (pageId: string | undefined) =>
  (state: RootState) =>
    pageId ? notebookPagesSelectors.selectById(state, pageId) : undefined;

export const makeSelectPageBlocks = (pageId: string | undefined) =>
  createSelector(
    (state: RootState) => state.pages.pageBlocks,
    (pageBlocks) => (pageId ? pageBlocks[pageId] : undefined),
  );

export const makeSelectDatabasePages = (folderId: string | undefined) =>
  createSelector(
    (state: RootState) => notebookPagesSelectors.selectAll(state),
    (pages) =>
      folderId ? pages.filter((p) => p["folder-id"] === folderId) : [],
  );

export const selectRootNotebookPages = createSelector(
  (state: RootState) => notebookPagesSelectors.selectIds(state),
  (state: RootState) => notebookPagesSelectors.selectEntities(state),
  (state: RootState) => state.pages.rootFolderId,
  (ids, entities, rootFolderId) =>
    !rootFolderId
      ? []
      : ids
          .map((id) => entities[id])
          .filter((p): p is NotebookPage => !!p && p["folder-id"] === rootFolderId),
);

export const selectNotebookPageIdMap = createSelector(
  (state: RootState) => state.pages.selectedNotebookPageId,
  (state: RootState) => notebookPagesSelectors.selectEntities(state),
  (selectedNotebookPageId, entities) => ({
    selectedNotebookPageId,
    selectedNotebookPage: selectedNotebookPageId
      ? entities[selectedNotebookPageId]
      : undefined,
  }),
);
